import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { LocaleSharedModule } from '@app/i18n/locale-shared.module';

import { FormFieldModule, ImageUploaderModule } from '@shared/form-controls';

import { OnUiButtonModule, OnUiInputModule, OnUiRadioModule, OnUiTextareaModule } from 'onclass-ui';
import { ClassroomFormComponent } from './classroom-form.component';
import { ClassroomParticipantsModule } from './classroom-participants/classroom-participants.module';

@NgModule({
  declarations: [ClassroomFormComponent],
  imports: [
    LocaleSharedModule,
    CommonModule,
    ReactiveFormsModule,

    OnUiInputModule,
    ImageUploaderModule,
    FormFieldModule,
    OnUiRadioModule,
    ClassroomParticipantsModule,
    OnUiTextareaModule,
    OnUiButtonModule,
  ],
  exports: [ClassroomFormComponent],
  providers: [],
})
export class ClassroomFormModule {}
